import { Box, Flex  } from '@chakra-ui/react';
import type { BoxProps, FlexProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import { ContentWrapper } from '../ContentWrapper/ContentWrapper';

const Root = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
	return (
		<ContentWrapper h="100%" minH={0} {...props}>
			{children}
		</ContentWrapper>
	);
};

const Wrapper = ({ children, ...props }: PropsWithChildren<FlexProps>) => {
	return (
		<Flex
			flexDir="column"
			gap="md"
			h="100%"
			minH={0}
			{...props}
		>
			{children}
		</Flex>
	);
};

const Scrollable = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
	return (
		<Box
			flex={1}
			minH={0}
			overflowY="auto"
			{...props}
			scrollbar="hidden"
		>
			{children}
		</Box>
	);
};

const Content = ({ children, ...props }: PropsWithChildren<BoxProps>) => (
	<Box flexShrink={0} {...props}>
		{children}
	</Box>
);

const Section = ({ children, ...props }: PropsWithChildren<BoxProps>) => (
	<Box flex="1 1 0" minH={0} {...props}>
		{children}
	</Box>
);

export const ScrollLayout = {
	Content,
	Root,
	Scrollable,
	Section,
	Wrapper,
};
